import { render } from "./Tools.vue?vue&type=template&id=0474a143&scoped=true&ts=true"
import script from "./Tools.vue?vue&type=script&lang=ts"
export * from "./Tools.vue?vue&type=script&lang=ts"

import "./Tools.vue?vue&type=style&index=0&id=0474a143&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0474a143"]])

export default __exports__